import * as t from "yup";
import { parse as e } from "date-fns";
const a = (e2, a2, r2, n2 = t.string) => {
  t.addMethod(n2, e2, function(t2) {
    return this.test(e2, t2, function(e3, n3) {
      const { path: s, createError: i } = this;
      return a2(e3, n3) || i({ path: s, message: t2 || r2 });
    });
  });
}, r = (t2) => {
  for (let e2 = 0; e2 < t2.length; e2++) if (!/^[a-zA-Z0-9]$/.test(t2[e2])) return true;
  return false;
};
a("specialSymbol", (t2) => r(t2)), a("hasUppercase", (t2) => /[A-Z]/.test(t2)), a("hasLowercase", (t2) => /[a-z]/.test(t2)), a("hasDigit", (t2) => /\d/.test(t2)), a("checkInvalidDate", (t2) => !t2 || "Invalid Date" !== new Date(t2).toString(), "Невірний формат");
const n = "Рік не може бути менше 1900";
a("checkMinDate", (t2) => {
  if (!t2) return true;
  return e(t2.replace(/T.*$/, ""), "yyyy-MM-dd", /* @__PURE__ */ new Date()).getFullYear() >= 1900;
}, n), a("checkExelType", (t2) => !t2 || ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"].includes(t2.type), "Невірний тип файлу", t.mixed), a("checkExcelSignature", async (t2) => {
  if (!t2) return true;
  const e2 = await t2.slice(0, 8).arrayBuffer(), a2 = [...new Uint8Array(e2)].map((t3) => t3.toString(16).padStart(2, "0")).join("");
  return !(!a2.startsWith("d0cf11e0a1b11ae1") && !a2.startsWith("504b0304"));
}, "Невірний тип файлу", t.mixed);
export {
  n as YUP_CHECK_MIN_DATE_ERROR_MESSAGE,
  a as createMethod,
  r as hasSpecialSymbol
};
//# sourceMappingURL=extendYupMethods.js.map
